<div *ngIf="selectedPOS && !connected">
    <div class="info">
        <div class="POS-logo"
             [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/lightspeed-thin-white.png)'}"></div>
        <!-- <div class="pos-title">Lightspeed</div> -->
        <div class="write-up">Lightspeed is a point-of-sale and e-commerce software provider based in Montreal, Quebec,
            Canada. Lightspeed provides small and medium sized retail and restaurant businesses with point of sale
            solutions.
        </div>
    </div>
</div>

<button type="button" (click)="connectLightspeed()" class="btn btn-primary"
        *ngIf="!busy && !connected && lightspeed_auth_url">Connect to Lightspeed
</button>
<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
</div>
<div class="wizard-message box center margin-top-0" *ngIf="connected && message">
    <div [innerHTML]="message"></div>
</div>
<div class="wizard-message fail center margin-top-16" *ngIf="message && !connected">
    <div [innerHTML]="message"></div>
</div>
<div *ngIf="connected" class="margin-top-16">
    <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
    <app-lightspeed-defaults [partner]="partner" (status)="configurationUpdate($event)"></app-lightspeed-defaults>
</div>
<div *ngIf="partner.VerificationID" class="margin-top-32">
    <div class="row">
        <div class="col-md-6">
            <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
                    label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}" *ngIf="!configurationSaved"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" (click)="done()" class="p-button primary full-width"
                    [disabled]="!configurationSaved"
                    label="{{ 'onboarding.button.done' | translate}}"></button>
        </div>
    </div>
</div>
